export interface Buffer {
  readonly lines: readonly string[];
}

export function createBuffer(lines: readonly string[]): Buffer {
  return { lines: lines.length > 0 ? lines : [""] };
}

export function lineCount(buffer: Buffer): number {
  return buffer.lines.length;
}

export function lastLineIndex(buffer: Buffer): number {
  return buffer.lines.length - 1;
}

export function lineAt(buffer: Buffer, line: number): string {
  return buffer.lines[line] ?? "";
}

export function lineLength(buffer: Buffer, line: number): number {
  return lineAt(buffer, line).length;
}

/** ノーマルモードでカーソルが取り得る最大列（空行は0、それ以外は行長-1）。 */
export function lastNormalModeCol(buffer: Buffer, line: number): number {
  const length = lineLength(buffer, line);
  return length === 0 ? 0 : length - 1;
}

export function isBlankLine(buffer: Buffer, line: number): boolean {
  return lineAt(buffer, line).trim().length === 0;
}
